import { ACTIONS } from "./constants";
import initializeSdk from "../util/sdk/umdLoader";
import apiFetch from '@wordpress/api-fetch';
import { defaultHooks } from "@wordpress/hooks";

const {
	websdkStyles: styles
} = PayoneerData;

export const getSdk = () => async ( { resolveSelect, dispatch } ) => {
	const env = await resolveSelect.getEnv();
	const longId = await resolveSelect.getLongId();
	const onBeforeError = async ( sdk, component, data ) => await dispatch.onBeforeError( sdk, component, data );
	const onPaymentDeclined = async ( sdk, component, data ) => await dispatch.onPaymentDeclined( sdk, component, data );
	const onComponentListChange = async ( sdk, changeInfo ) => await dispatch.onComponentListChange( sdk, changeInfo );
	const onValidationInfo = async ( sdk, componentName, data ) => await dispatch.onValidationInfo( sdk, componentName, data );

	const sdk = await initializeSdk( {
		env,
		onBeforeError,
		onPaymentDeclined,
		onComponentListChange,
		onValidationInfo,
		preload: [ 'cards' ],
		styles
	} );

	if ( sdk.state === 'LOADING' ) {
		const nonLoadingState = async () => {
			return await new Promise( resolve => {
				const interval = setInterval( () => {
					if ( sdk.state !== 'LOADING' ) {
						resolve( sdk.state );
						clearInterval( interval );
					}
				}, 1000 );
			} );
		};
		await nonLoadingState();
	}
	await sdk.updateLongId( longId );
	await dispatch.setForceHostedFlow( false );
	await dispatch.setSdkState( sdk.state );
	await dispatch( { type: ACTIONS.SET_SDK, payload: sdk } );
}
/**
 * Perform a Store API call to the cart endpoint where we provide LIST longId and environment
 */
export const getExtensionData = () => async ( { dispatch } ) => {

	const response = await apiFetch( {
		/**
		 * /wc/store/v1/cart
		 * is pre-warmed in PHP, so the first API call will always get data produced during
		 * the initial page load.
		 * Here we MUST receive the results of an actual API call.
		 * So we use a custom URL hash to prevent this from happening.
		 */
		path: '/wc/store/v1/cart#skipPreloadingMiddleware',
		method: 'GET',
		cache: 'no-store',
		parse: false,
	} );
	const json = await response.json();
	const payoneerExtensionData = json.extensions[ 'payoneer-checkout' ];
	console.log('Payoneer Extension Data: ', payoneerExtensionData);
	await dispatch( { type: ACTIONS.SET_EXTENSION_DATA, payload: payoneerExtensionData } );
	defaultHooks.doAction( 'payoneer.checkout.onReceiveExtensionData', payoneerExtensionData )
}
export const getLongId = () => async ( { resolveSelect,dispatch } ) => {
	const extensionData = await resolveSelect.getExtensionData();
	await dispatch( { type: ACTIONS.SET_LONG_ID, payload: extensionData.longId } );
}

export const getEnv = () => async ( { resolveSelect,dispatch } ) => {
	const extensionData = await resolveSelect.getExtensionData();
	await dispatch( { type: ACTIONS.SET_ENV, payload: extensionData.environment } );
}
